import { FC, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Select, Table, TableColumnsType } from 'antd';

import Button from '../../Button';
import EditSubjectModal from './modals/EditSubjectModal';
import {
  IGetSemesterCoursesSubject,
  ISemesterCoursesSubjectUpdateBody,
  ISemesterCourseSubjectData,
} from '../../../models/semesterCoursesSubject.model';
import useNotification from '../../../hooks/useNotification';
import useAxios from '../../../hooks/useAxios';
import {
  getSemesterCoursesSubject,
  postSemesterCoursesSubject,
  putSemesterCoursesSubject,
} from '../../../api/semesterCoursesSubject.api';
import ErrorResponse from '../../ErrorResponse';
import Loader from '../../Loader';
import { SEMESTER_TYPE } from '../../../constans';

const { Option } = Select;

interface IProps {
  courseInput: any;
  courseList: any[];
  onSetCourseInput: Function;
  renderCourseInfo: Function;
  setTimesIndex: Function;
  setTimesInputVisible: Function;
  getSemesterCode: (courseDetailCode: number) => number;
  selSemesterType: string;
}

const SemesterCourse2: FC<IProps> = ({
  courseInput,
  courseList,
  onSetCourseInput,
  renderCourseInfo,
  setTimesIndex,
  setTimesInputVisible,
  getSemesterCode,
  selSemesterType,
}) => {
  const { data: res, isLoading, error, execute } = useAxios();
  const {
    data: res2,
    isLoading: isLoading2,
    error: error2,
    execute: execute2,
  } = useAxios<IGetSemesterCoursesSubject>();
  const {
    data: res3,
    isLoading: isLoading3,
    error: error3,
    execute: execute3,
  } = useAxios();
  const { t } = useTranslation();
  const { infoNotification, successNotification } = useNotification();

  const [filteredCourseList, setFilteredCourseList] = useState<any>();
  const [visible, setVisible] = useState(false);
  const [course, setCourse] = useState<number>(0);

  const onOk = (
    data: ISemesterCourseSubjectData[],
    status: 'Create' | 'Update',
  ) => {
    const total = data
      .filter((data) => data.status !== 'delete')
      .reduce((total, item) => total + item.weekLessonCount, 0);

    if (
      total !==
      renderCourseInfo(course, 'weekLectureCount') *
        renderCourseInfo(course, 'dayLessonCount')
    ) {
      return infoNotification(t('program.semester.1'));
    }
    const filter = data.filter(
      ({ weekLessonCount, subjectCode }) =>
        weekLessonCount === 0 || subjectCode === 0,
    );
    if (filter.length >= 1) {
      return infoNotification(t('program.semester.2'));
    }

    if (status === 'Create') {
      const newData = data.map((item) => {
        item.totalLessonCount = item.weekLessonCount * 12;
        return item;
      });

      execute(postSemesterCoursesSubject(newData));
    } else {
      const newData = data.map<ISemesterCoursesSubjectUpdateBody>(
        ({
          weekLessonCount,
          subjectCode,
          courseSubjectCode,
          semesterCourseCode,
          status,
        }) => ({
          totalLessonCount: weekLessonCount * 12,
          weekLessonCount: weekLessonCount,
          subjectCode: subjectCode,
          courseSubjectCode: courseSubjectCode!!,
          semesterCourseCode: semesterCourseCode,
          status: status,
        }),
      );

      execute3(putSemesterCoursesSubject(newData));
    }
  };

  const onSubjectClick = (index: number) => {
    setCourse(courseInput[index].course);
    execute2(
      getSemesterCoursesSubject({
        semesterCourseCode: getSemesterCode(
          renderCourseInfo(courseInput[index].course, 'courseDetailCode'),
        ),
      }),
    );
  };

  useEffect(() => {
    if (courseList && courseInput) {
      const selectedCourses: number[] = courseInput.map(
        (item: any) => item.course,
      );
      const list: any = [];
      courseList.forEach((item: any) => {
        if (!selectedCourses.includes(item.value)) {
          list.push(item);
        }
      });
      setFilteredCourseList(list);
    }
  }, [courseList, courseInput]);

  useEffect(() => {
    if (res) {
      successNotification(t('common.message.save1'));
      setVisible(false);
    }
  }, [res]);

  useEffect(() => {
    if (res2) {
      setVisible(true);
    }
  }, [res2]);

  useEffect(() => {
    if (res3) {
      successNotification(t('common.message.edit1'));
      setVisible(false);
    }
  }, [res3]);

  const getOptionLabel = (value: number) => {
    const course = courseList.find((item: any) => item.value === value);
    return course ? course.label : '';
  };

  const columns: TableColumnsType<any> = [
    {
      title: t('program.semester.column5'),
      key: 'course',
      render: (value, record, index) => (
        <div className="w-100" style={{ minWidth: '100px' }}>
          <Select
            className="w-100"
            value={courseInput[index].course}
            onChange={(value) => onSetCourseInput(index, 'course', value)}
            disabled={courseInput[index].id}
            // 임시해제
            // disabled={isDisabled}
          >
            <Option value={courseInput[index].course}>
              {courseInput[index].courseDetailName || getOptionLabel(courseInput[index].course)}
            </Option>
            {filteredCourseList?.map((item: any) => {
              return (
                <Option key={item.value} value={item.value}>
                  {item.label}
                </Option>
              );
            })}
          </Select>
        </div>
      ),
    },
    {
      title: t('program.semester.column2'),
      key: 'levelName',
      render: (value, record, index) => {
        return courseInput[index].course
          ? renderCourseInfo(courseInput[index].course, 'levelName')
          : '-';
      },
    },
    {
      title: t('program.semester.column3'),
      key: 'stepName',
      render: (value, record, index) => {
        return courseInput[index].course
          ? renderCourseInfo(courseInput[index].course, 'stepName')
          : '-';
      },
    },
    {
      title: t('program.semester.column17'),
      key: 'weekLectureCount',
      render: (value, record, index) => {
        return courseInput[index].course
          ? `${t('program.course.text1')} ${renderCourseInfo(
              courseInput[index].course,
              'weekLectureCount',
            )} ${t('program.course.text2')}`
          : '-';
      },
    },
    {
      title: t('program.semester.column18'),
      key: 'onlineTuition',
      render: (value, record, index) => {
        return renderCourseInfo(courseInput[index].course, 'onlineTuition') ===
          0 || renderCourseInfo(courseInput[index].course, 'onlineTuition')
          ? `${renderCourseInfo(
              courseInput[index].course,
              'onlineTuition',
            ).toLocaleString()} ${t('program.course.text7')}`
          : '-';
      },
    },
    {
      title: t('program.semester.column19'),
      key: 'alexTuition',
      render: (value, record, index) => {
        return renderCourseInfo(courseInput[index].course, 'alexTuition') ===
          0 || renderCourseInfo(courseInput[index].course, 'alexTuition')
          ? `${renderCourseInfo(
              courseInput[index].course,
              'alexTuition',
            ).toLocaleString()} ${t('program.course.text7')}`
          : '-';
      },
    },
    {
      title: '',
      key: 'buttons',
      render: (value, record, index) => (
        <>
        {SEMESTER_TYPE.SPECIAL_CLASS !== selSemesterType &&
        <div className="comm-btn__area justify-content-center">
          {courseInput[index] ? (
            <Button
              className="btn-basic small mint"
              onClick={() => {
                setTimesIndex(index);
                setTimesInputVisible(true);
              }}
              text={t('program.semester.button5')}
            />
          ) : null}
          <Button
            className="btn-basic small mint"
            text={t('program.semester.3')}
            onClick={() => onSubjectClick(index)}
          />
        </div>}
        </>
      ),
    },
  ];

  return (
    <>
      {(isLoading || isLoading2 || isLoading3) && <Loader />}
      <ErrorResponse error={error} />
      <ErrorResponse error={error2} />
      <ErrorResponse error={error3} />
      <Table
        className='comm-table__area'
        columns={columns}
        dataSource={courseInput}
        pagination={{ pageSize: 99999 }}
        rowKey="index"
      />      
      {visible && (
        <EditSubjectModal
          level={getOptionLabel(course)}
          semesterCourseCode={getSemesterCode(
            renderCourseInfo(course, 'courseDetailCode'),
          )}
          onClose={() => setVisible(false)}
          onOk={onOk}
          semesterCoursesSubject={res2?.data ?? []}
        />
      )}
    </>
  );
};

export default SemesterCourse2;
